import { STORAGE_ALLKEYS, STORAGE_KEY_KEEP_LOGGEDIN } from "./constStorageKeys";

 class TypeStorage{

   public storage: Storage;

    constructor(){
        this.loadStorage( this.statusKeepLoggedIn() );
    }

    public loadStorage( keepLoggedIn: boolean): void{
        if(  keepLoggedIn  ){
            this.storage = localStorage;
            this.clearKnownKeys(sessionStorage);
        }else{
            this.storage = sessionStorage;
            this.clearKnownKeys(localStorage);
        }
    }

    private clearKnownKeys(targetStorage: Storage): void{
        if(targetStorage.length > 0){
            STORAGE_ALLKEYS.forEach((key: string) => {
                targetStorage.removeItem(key);
            });
        }
    }

   private statusKeepLoggedIn(): boolean{
       
    const value = localStorage.getItem( STORAGE_KEY_KEEP_LOGGEDIN );
    
    if(!value){
       return false;
    }

     return true;
}
}

export default new TypeStorage();